import useFetchCommonContractData, { CommonContractData } from './useFetchCommonContractData'
import useFetchFrenchContractData, { FrenchContractData } from './useFetchFrenchContractData'
import useFetchGermanContractData, { GermanContractData } from './useFetchGermanContractData'
import useFetchPortugueseContractData, {
  PortugueseContractData,
} from './useFetchPortugueseContractData'
import useFetchSpanishContractData, { SpanishContractData } from './useFetchSpanishContractData'

interface LegalEntityContractData {
  loading: boolean
  spanishContractData: SpanishContractData
  frenchContractData: FrenchContractData
  germanContractData: GermanContractData
  portugueseContractData: PortugueseContractData
  commonContractData: CommonContractData
}

const useFetchLegalEntityContractData = (
  legalEntityId: number,
  country: string,
  notHidden?: boolean
): LegalEntityContractData => {
  const spanishContractData = useFetchSpanishContractData(legalEntityId, country, notHidden)
  const frenchContractData = useFetchFrenchContractData(country, notHidden)
  const germanContractData = useFetchGermanContractData(country, notHidden)
  const portugueseContractData = useFetchPortugueseContractData(country, notHidden)
  const commonContractData = useFetchCommonContractData(legalEntityId)
  const loading =
    spanishContractData.loading ||
    frenchContractData.loading ||
    germanContractData.loading ||
    portugueseContractData.loading ||
    commonContractData.loading

  return {
    loading,
    spanishContractData,
    frenchContractData,
    germanContractData,
    portugueseContractData,
    commonContractData,
  }
}

export default useFetchLegalEntityContractData
